import "./App.css";
// import Find from "./Components/Find";
import Footer from "./Components/Footer";
import About from "./Components/About";
// import Signup from "./Components/Signup";
import News from "./Components/News";
// import Count from "./Components/Count";
import Testimonials from "./Components/Testimonials";
import Why from "./Components/Why";
import Services from "./Components/Services";
import Header from "./Components/Header";
import Home from "./Components/Home";
import Ourservices from "./Components/Ourservices-1";
import Team from "./Components/Team";
import Appointment from "./Components/Appointment";

function App() {
  return (
    <>
      <Header />
      <Home />
      <About />
      <Team />
      <Ourservices />
      <Services />
      <Why />
      <Testimonials />
      <News />
      <Appointment />
      <Footer />
    </>
  );
}

export default App;
